<div class="live-preview p-4 custom-scroll-height-2 d-flex flex-column justify-content-between">
  <div>
    <div class="mb-3">
      <a
        href="javascript:;"
        data-bs-toggle="collapse"
        aria-expanded="false"
        aria-controls="collapseblock"
        (click)="BlockCollapse.toggle(); goToStep(1)"
        [attr.aria-expanded]="!BlockCollapsed"
      >
        <h5 class="mb-3">
          {{ "label-title.passenger-details" | translate }}
          @if(BlockCollapsed){
          <svg xmlns="http://www.w3.org/2000/svg" width="11" height="6" viewBox="0 0 11 6" fill="none">
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M5.72115 5.75875C5.60225 5.88846 5.39775 5.88846 5.27885 5.75875L0.460824 0.502718C0.284439 0.310298 0.420939 9.24851e-07 0.68197 9.02031e-07L10.318 5.96198e-08C10.5791 3.67997e-08 10.7156 0.310297 10.5392 0.502718L5.72115 5.75875Z"
              fill="currentColor"
            />
          </svg>
          } @else {
          <svg xmlns="http://www.w3.org/2000/svg" width="11" height="6" viewBox="0 0 11 6" fill="none">
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M5.27885 0.24125C5.39775 0.11154 5.60225 0.11154 5.72115 0.24125L10.5392 5.49728C10.7156 5.6897 10.5791 6 10.318 6H0.681971C0.420939 6 0.284439 5.6897 0.460824 5.49728L5.27885 0.24125Z"
              fill="currentColor"
            />
          </svg>
          }
        </h5>
      </a>
    </div>
    <div class="row g-2 mb-3">
      <div class="col-auto">
        <div class="collapse show" id="collapseblock" #BlockCollapse="ngbCollapse" [(ngbCollapse)]="BlockCollapsed">
          <div class="details-form">
            <form class="px-2" [formGroup]="userForm">
              <div class="row">
                <div class="col-12">
                  <div class="form-group mb-2">
                    <div class="position-relative">
                      <div class="input-group">
                        <button href="javascript:void(0);" class="input-group-text" id="basic-addon1" (click)="onCountryChange()" [disabled]="isCountryCodeDisabled()">
                          {{ userForm.value.countryPhoneCode }}
                        </button>

                        <input
                          type="text"
                          class="form-control phone_number"
                          formControlName="phone"
                          (keypress)="helper.numberValidation($event)"
                          (input)="onPhoneChange()"
                          (keyup.enter)="onCustomerSearch()"
                          placeholder="{{ 'label-title.mobile-number' | translate }}"
                          aria-label="Username"
                          aria-describedby="basic-addon1"
                        />
                        @if(!customerDetails){
                        <i class="bx bx-search clear-icon c-pointer" (click)="onCustomerSearch()"></i>
                        }
                      </div>
                      @if(customerDetails){
                      <i class="mdi mdi-close-circle-outline clear-icon" (click)="clearUserForm()"></i>
                      }
                    </div>
                    @if(controls['phone'].invalid && controls['phone'].touched){ @if(controls['phone'].hasError('required')){
                    <div class="invalid-message">{{ "label-title.phone" | translate }} {{ "label-title.is-required" | translate }}</div>
                    } @else if(controls['phone'].hasError('minlength')){
                    <div class="invalid-message">{{ "label-title.phone" | translate }} {{ "label-title.is-too-small" | translate }}</div>
                    } }
                  </div>
                </div>
                <div class="col-12">
                  <div class="form-group mb-2">
                    <input
                      type="text"
                      class="form-control"
                      formControlName="firstName"
                      [readOnly]="customerDetails?._id"
                      placeholder="Name"
                      (keypress)="helper.alphabeticValidation($event)"
                    />
                    @if(controls['firstName'].errors){
                    <div class="invalid-message">
                      <p class="m-0">
                        @if (controls['firstName'].hasError('required') && controls['firstName'].touched) {
                        Name is required
                        } @if (controls['firstName'].hasError('maxlength')) {
                        <span>
                          {{ "label-title.maximum-characters-allowed" | translate : { _CHARACTER: helper.NameMaxLength * 2 + 1 } }}
                        </span>
                        } @if (controls['firstName'].hasError('invalidCharacters')) {
                        <span>{{ "validation-title.please-enter-valid-characters" | translate }}</span>
                        }
                      </p>
                    </div>
                    }
                  </div>
                </div>
                <div class="col-12">
                  <div class="form-group mb-3">
                    <input type="text" class="form-control" formControlName="email" [readOnly]="customerDetails?._id" placeholder="{{ 'label-title.email' | translate }}" />
                    @if(controls['email'].invalid && controls['email'].touched){ @if(controls['email'].hasError('pattern')){
                    <div class="invalid-message">
                      {{ "validation-title.email-is-invalid" | translate }}
                    </div>
                    } }
                  </div>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
      <!--end col-->
    </div>

    @if(oneScreen || currentStep > 1){
    <a
      href="javascript:;"
      data-bs-toggle="collapse"
      data-bs-target="#collapseinline"
      [attr.aria-expanded]="!BlockCollapsedTwo"
      aria-expanded="true"
      aria-controls="collapseinline"
      (click)="BlockCollapseTwo.toggle(); goToStep(2)"
    >
      <h5 class="mb-3">
        {{ "label-title.ride-details" | translate }}
        @if(BlockCollapsedTwo){
        <svg xmlns="http://www.w3.org/2000/svg" width="11" height="6" viewBox="0 0 11 6" fill="none">
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M5.72115 5.75875C5.60225 5.88846 5.39775 5.88846 5.27885 5.75875L0.460824 0.502718C0.284439 0.310298 0.420939 9.24851e-07 0.68197 9.02031e-07L10.318 5.96198e-08C10.5791 3.67997e-08 10.7156 0.310297 10.5392 0.502718L5.72115 5.75875Z"
            fill="currentColor"
          />
        </svg>
        } @else {
        <svg xmlns="http://www.w3.org/2000/svg" width="11" height="6" viewBox="0 0 11 6" fill="none">
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M5.27885 0.24125C5.39775 0.11154 5.60225 0.11154 5.72115 0.24125L10.5392 5.49728C10.7156 5.6897 10.5791 6 10.318 6H0.681971C0.420939 6 0.284439 5.6897 0.460824 5.49728L5.27885 0.24125Z"
            fill="currentColor"
          />
        </svg>
        }
      </h5>
    </a>
    <div class="row g-2 mb-3">
      <div class="col-12">
        <div class="collapse show" id="collapseblock" #BlockCollapseTwo="ngbCollapse" [(ngbCollapse)]="BlockCollapsedTwo">
          <div class="details-form">
            <div class="mb-3">
              @for(type of DispatcherBookingType ; track $index){
              <span
                class="btn btn-soft-dark waves-effect waves-light btn-sm"
                [ngClass]="{ 'me-2': $index != DispatcherBookingType.length - 1, active: type?.isActive }"
                (click)="onAddressEdit(currentStep); typeClick(type)"
                >{{ type?.string | translate }}</span
              >
              }
            </div>
            <form class="px-2" [formGroup]="rideDetailsForm">
              <div class="row">
                <div class="location col-12 mb-4">
                  <div class="pickup ps-4" [ngClass]="{ 'pe-4': currentStep == 2, 'mb-2': currentStep != 2 || !this.isMultipleLocations }">
                    <div class="position-relative">
                      <input
                        type="text"
                        (input)="onInputChange($event)"
                        id="pickup-address"
                        autocomplete="off"
                        class="form-control"
                        (focus)="resetPrediction()"
                        formControlName="pickup"
                        [readonly]="!oneScreen && currentStep > 2"
                        placeholder="{{ 'label-title.enter-pickup' | translate }}"
                        (click)="onAddressEdit(currentStep)"
                      />
                      @if(currentStep == 2){
                      <div class="remove-icon c-pointer" (click)="clearAddress(helper.AddressType.PICKUP)">
                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                          <path
                            opacity="0.2"
                            d="M8 0C3.581 0 0 3.582 0 8C0 12.418 3.581 16 8 16C12.419 16 16 12.418 16 8C16 3.582 12.419 0 8 0ZM11.707 10.293C11.8945 10.4805 11.9998 10.7348 11.9998 11C11.9998 11.2652 11.8945 11.5195 11.707 11.707C11.5195 11.8945 11.2652 11.9998 11 11.9998C10.7348 11.9998 10.4805 11.8945 10.293 11.707L8 9.414L5.707 11.707C5.61435 11.8002 5.50419 11.8741 5.38285 11.9246C5.26152 11.9751 5.13141 12.001 5 12.001C4.86859 12.001 4.73848 11.9751 4.61715 11.9246C4.49581 11.8741 4.38565 11.8002 4.293 11.707C4.20005 11.6142 4.12632 11.504 4.07601 11.3827C4.0257 11.2614 3.9998 11.1313 3.9998 11C3.9998 10.8687 4.0257 10.7386 4.07601 10.6173C4.12632 10.496 4.20005 10.3858 4.293 10.293L6.586 8L4.293 5.707C4.10549 5.51949 4.00015 5.26518 4.00015 5C4.00015 4.73482 4.10549 4.48051 4.293 4.293C4.48051 4.10549 4.73482 4.00015 5 4.00015C5.26518 4.00015 5.51949 4.10549 5.707 4.293L8 6.586L10.293 4.293C10.4805 4.10549 10.7348 4.00015 11 4.00015C11.2652 4.00015 11.5195 4.10549 11.707 4.293C11.8945 4.48051 11.9998 4.73482 11.9998 5C11.9998 5.26518 11.8945 5.51949 11.707 5.707L9.414 8L11.707 10.293Z"
                            fill="currentColor"
                          />
                        </svg>
                      </div>
                      } @if(this.predictions.length > 0) {
                      <ul class="autocomplete-dropdown">
                        @for (prediction of this.predictions; track $index) {
                        <li class="text-ellipsis" [class.selected]="isSelected($index)" (click)="onPredictionSelect(prediction)">
                          {{ prediction.description }}
                        </li>
                        }
                        <img src="../../../../assets/images/default-images/google_images/google_on_white.png" alt="Google Logo" class="p-2" />
                      </ul>
                      } @if (mapBoxSuggestions.length > 0) {
                      <ul class="autocomplete-dropdown">
                        @for (suggestion of mapBoxSuggestions; track $index) {
                        <li [class.selected]="isSelected($index)" (click)="onSelect(suggestion)">
                          {{ suggestion.place_name }}
                        </li>
                        }
                      </ul>
                      }
                    </div>
                  </div>
                  @if(addressControls['pickup'].invalid && addressControls['pickup'].touched){ @if(addressControls['pickup'].hasError('required')){
                  <div class="invalid-message ps-4">{{ "label-title.pickup" | translate }} {{ "label-title.is-required" | translate }}</div>
                  } }
                  <!-- Dynamic Stops -->
                  <div
                    class="mt-2 stop"
                    formArrayName="stops"
                    *ngFor="let stop of stops.controls; let i = index"
                    [ngClass]="{ 'pe-4': currentStep == 2, 'mb-2': currentStep != 2 }"
                  >
                    <span class="stop_number">{{ i + 1 }}</span>

                    <div class="ps-4">
                      <div class="position-relative" [formGroupName]="i">
                        <input
                          type="text"
                          placeholder="{{ 'label-title.enter-stop' | translate }} {{ i + 1 }}"
                          formControlName="address"
                          autocomplete="off"
                          class="form-control"
                          (input)="onInputChange($event)"
                          [readonly]="!oneScreen && currentStep > 2"
                          (focus)="resetPrediction()"
                          id="stop-address{{ i }}"
                          (click)="onAddressEdit(currentStep)"
                        />
                        @if(currentStep == 2){
                        <div class="remove-icon c-pointer" (click)="removeStop(i)">
                          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                            <path
                              opacity="0.2"
                              d="M8 0C3.581 0 0 3.582 0 8C0 12.418 3.581 16 8 16C12.419 16 16 12.418 16 8C16 3.582 12.419 0 8 0ZM11.707 10.293C11.8945 10.4805 11.9998 10.7348 11.9998 11C11.9998 11.2652 11.8945 11.5195 11.707 11.707C11.5195 11.8945 11.2652 11.9998 11 11.9998C10.7348 11.9998 10.4805 11.8945 10.293 11.707L8 9.414L5.707 11.707C5.61435 11.8002 5.50419 11.8741 5.38285 11.9246C5.26152 11.9751 5.13141 12.001 5 12.001C4.86859 12.001 4.73848 11.9751 4.61715 11.9246C4.49581 11.8741 4.38565 11.8002 4.293 11.707C4.20005 11.6142 4.12632 11.504 4.07601 11.3827C4.0257 11.2614 3.9998 11.1313 3.9998 11C3.9998 10.8687 4.0257 10.7386 4.07601 10.6173C4.12632 10.496 4.20005 10.3858 4.293 10.293L6.586 8L4.293 5.707C4.10549 5.51949 4.00015 5.26518 4.00015 5C4.00015 4.73482 4.10549 4.48051 4.293 4.293C4.48051 4.10549 4.73482 4.00015 5 4.00015C5.26518 4.00015 5.51949 4.10549 5.707 4.293L8 6.586L10.293 4.293C10.4805 4.10549 10.7348 4.00015 11 4.00015C11.2652 4.00015 11.5195 4.10549 11.707 4.293C11.8945 4.48051 11.9998 4.73482 11.9998 5C11.9998 5.26518 11.8945 5.51949 11.707 5.707L9.414 8L11.707 10.293Z"
                              fill="currentColor"
                            />
                          </svg>
                        </div>
                        } @if(this.stopPrediction.length > 0 && this.addedStopNumber == i) {
                        <ul class="autocomplete-dropdown">
                          @for (prediction of this.stopPrediction; track $index) {
                          <li class="text-ellipsis" [class.selected]="isSelected($index)" (click)="onPredictionSelect(prediction)">
                            {{ prediction.description }}
                          </li>
                          }
                          <img src="../../../../assets/images/default-images/google_images/google_on_white.png" alt="Google Logo" class="p-2" />
                        </ul>
                        } @if (mapBoxSuggestionsForStop.length > 0) {
                        <ul class="autocomplete-dropdown">
                          @for (suggestion of mapBoxSuggestionsForStop; track $index) {
                          <li [class.selected]="isSelected($index)" (click)="onSelect(suggestion)">
                            {{ suggestion.place_name }}
                          </li>
                          }
                        </ul>
                        }
                      </div>
                    </div>

                    @if(stop.get('address')?.invalid && stop.get('address')?.touched || stop.get('stopAddress')?.invalid){
                    <div class="invalid-message ps-4">
                      @if(stop.get('address')?.errors?.['required']){
                      {{ "label-title.stop" | translate }} {{ "label-title.is-required" | translate }}
                      } @else if (stop.get('stopAddress')?.hasError('duplicateAddress')) {
                      {{ "validation-title.entered-location-must-be-unique" | translate }}
                      }
                    </div>
                    }
                  </div>
                  @if(this.isMultipleLocations && currentStep == 2){
                  <div class="text-end py-2 pe-4">
                    <button class="btn btn-primary btn-sm" type="button" (click)="addStop()">{{ "button-title.add-stop" | translate }}</button>
                  </div>
                  }
                  <div class="drop-off ps-4" [ngClass]="{ 'pe-4': currentStep == 2 }">
                    <div class="position-relative">
                      <input
                        type="text"
                        (input)="onInputChange($event)"
                        id="destination-address"
                        autocomplete="off"
                        class="form-control"
                        [readonly]="!oneScreen && currentStep > 2"
                        formControlName="dropOff"
                        (focus)="resetPrediction()"
                        placeholder="{{ 'label-title.enter-dropoff' | translate }}"
                        (click)="onAddressEdit(currentStep)"
                      />
                      @if(currentStep == 2){
                      <div class="remove-icon c-pointer" (click)="clearAddress(helper.AddressType.DESTINATION)">
                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                          <path
                            opacity="0.2"
                            d="M8 0C3.581 0 0 3.582 0 8C0 12.418 3.581 16 8 16C12.419 16 16 12.418 16 8C16 3.582 12.419 0 8 0ZM11.707 10.293C11.8945 10.4805 11.9998 10.7348 11.9998 11C11.9998 11.2652 11.8945 11.5195 11.707 11.707C11.5195 11.8945 11.2652 11.9998 11 11.9998C10.7348 11.9998 10.4805 11.8945 10.293 11.707L8 9.414L5.707 11.707C5.61435 11.8002 5.50419 11.8741 5.38285 11.9246C5.26152 11.9751 5.13141 12.001 5 12.001C4.86859 12.001 4.73848 11.9751 4.61715 11.9246C4.49581 11.8741 4.38565 11.8002 4.293 11.707C4.20005 11.6142 4.12632 11.504 4.07601 11.3827C4.0257 11.2614 3.9998 11.1313 3.9998 11C3.9998 10.8687 4.0257 10.7386 4.07601 10.6173C4.12632 10.496 4.20005 10.3858 4.293 10.293L6.586 8L4.293 5.707C4.10549 5.51949 4.00015 5.26518 4.00015 5C4.00015 4.73482 4.10549 4.48051 4.293 4.293C4.48051 4.10549 4.73482 4.00015 5 4.00015C5.26518 4.00015 5.51949 4.10549 5.707 4.293L8 6.586L10.293 4.293C10.4805 4.10549 10.7348 4.00015 11 4.00015C11.2652 4.00015 11.5195 4.10549 11.707 4.293C11.8945 4.48051 11.9998 4.73482 11.9998 5C11.9998 5.26518 11.8945 5.51949 11.707 5.707L9.414 8L11.707 10.293Z"
                            fill="currentColor"
                          />
                        </svg>
                      </div>
                      } @if(this.destinationPredictions.length > 0) {
                      <ul class="autocomplete-dropdown">
                        @for (prediction of this.destinationPredictions; track $index) {
                        <li class="text-ellipsis" [class.selected]="isSelected($index)" (click)="onPredictionSelect(prediction)">
                          {{ prediction.description }}
                        </li>
                        }
                        <img src="../../../../assets/images/default-images/google_images/google_on_white.png" alt="Google Logo" class="p-2" />
                      </ul>
                      } @if (mapBoxSuggestionsForDestination.length > 0) {
                      <ul class="autocomplete-dropdown">
                        @for (suggestion of mapBoxSuggestionsForDestination; track $index) {
                        <li [class.selected]="isSelected($index)" (click)="onSelect(suggestion)">
                          {{ suggestion.place_name }}
                        </li>
                        }
                      </ul>
                      }
                    </div>
                  </div>
                  @if(addressControls['dropOff'].invalid && addressControls['dropOff'].touched || addressControls['dropOffAddress'].invalid){
                  <div class="invalid-message ps-4">
                    @if(addressControls['dropOff'].hasError('required')){
                    {{ "label-title.drop-off" | translate }} {{ "label-title.is-required" | translate }}
                    }@else if(addressControls['dropOffAddress'].hasError('sameLocation')) {
                    {{ "validation-title.same-pickup-drop-location" | translate }}
                    } @else if (addressControls['dropOffAddress'].hasError('duplicateAddress')) {
                    {{ "validation-title.entered-location-must-be-unique" | translate }}
                    }
                  </div>
                  }
                </div>
                @if(oneScreen || this.currentStep !== 2){
                <div class="col-12 my-4">
                  <div class="d-flex align-items-center justify-content-between mb-3">
                    <h5 class="mb-0">{{ "label-title.choose-vehicle" | translate }}</h5>
                    <div class="d-flex">
                      @if(bookingSetting?.ShowFareEstimationInDetail){ @if(rideDetailsForm.value.vehicleType && rideDetailsForm.value.bookingType !== helper.BookingType.RENTAL){
                      <button class="btn btn-primary btn-sm" (click)="viewEstimate()">{{ "button-title.view-fare-estimate" | translate }}</button>
                      } @else if(rideDetailsForm.value.bookingType === helper.BookingType.RENTAL && rideDetailsForm.value.rentalPackage){
                      <button class="btn btn-primary btn-sm" (click)="viewEstimate()">{{ "button-title.view-fare-estimate" | translate }}</button>
                      } } @if( vehicleTypesData?.accessibilities > 0 || vehicleTypesData?.countrySetting?.isAllowGenderSelection ||
                      vehicleTypesData?.countrySetting?.speakingLanguages?.length > 0 || bookingSetting?.allowNoOfSeatSelection ){

                      <div class="d-flex ms-3">
                        <a href="javascript:void(0);" (click)="openBookingVehicleFilterModal()">
                          <i class="bx bx-slider-alt text-primary" style="font-size: 22px"></i>
                        </a>
                      </div>
                      }
                    </div>
                  </div>
                  <div class="form-group vehicle-type-select">
                    <ng-select
                      id="driver-map-city"
                      formControlName="vehicleType"
                      [searchable]="true"
                      [clearable]="false"
                      placeholder="{{ 'label-title.select-car' | translate }}"
                      [items]="vehicleTypeList"
                      bindLabel="vehicleTypeDetail.name"
                      bindValue="vehicleTypeId"
                      (change)="onTypeChange($event)"
                    >
                      <ng-template ng-option-tmp let-item="item">
                        <div class="d-flex justify-content-between align-items-center">
                          <div>
                            <span class="font-weight-medium d-flex align-items-center gap-2"
                              >{{ item.vehicleTypeDetail.name | translate }}
                              <div class="passenger-capacity">
                                ( <em class="bx bxs-user"></em><span>{{ item.vehicleTypeDetail.passengerCapacity }}</span>
                                )
                              </div>
                            </span>
                            @if(bookingSetting?.ShowDriverEstimation){
                            <p class="fs-12 mb-0">{{ calculateDurationAndEta(item.duration) }}</p>
                            }
                          </div>
                          @if(bookingSetting?.ShowFareEstimation){ @if(rideDetailsForm.value.bookingType !== helper.BookingType.RENTAL){
                          <div class="font-weight-medium">
                            <span class="d-flex currency-gap justify-content-end">
                              {{ item.priceDetail?.total.toFixed(countrySetting.decimalPointValue) }}
                              <span [ngClass]="{ 'order-first': countrySetting.setCurrencySign == helper.SetCurrencySignUnit.LEFT }">
                                {{ countrySetting.currencySign }}
                              </span>
                            </span>
                          </div>
                          } }
                        </div>
                      </ng-template>

                      <ng-template ng-label-tmp let-item="item">
                        <!-- {{ item.vehicleTypeDetail.name | translate }} -->
                        <div class="d-flex justify-content-between align-items-center py-2">
                          <div>
                            <span class="font-weight-medium d-flex align-items-center gap-2"
                              >{{ item.vehicleTypeDetail.name | translate }}
                              <div class="passenger-capacity">
                                ( <em class="bx bxs-user"></em><span>{{ item.vehicleTypeDetail.passengerCapacity }}</span>
                                )
                              </div>
                            </span>
                            @if(bookingSetting?.ShowDriverEstimation){
                            <p class="fs-12 mb-0">{{ calculateDurationAndEta(item.duration) }}</p>
                            }
                          </div>
                          @if(bookingSetting?.ShowFareEstimation){ @if(rideDetailsForm.value.bookingType !== helper.BookingType.RENTAL){
                          <div class="font-weight-medium">
                            <span class="d-flex currency-gap justify-content-end">
                              {{ item.priceDetail?.total.toFixed(countrySetting.decimalPointValue) }}
                              <span [ngClass]="{ 'order-first': countrySetting.setCurrencySign == helper.SetCurrencySignUnit.LEFT }">
                                {{ countrySetting.currencySign }}
                              </span>
                            </span>
                          </div>
                          } }
                        </div>
                      </ng-template>
                    </ng-select>
                    @if(addressControls['vehicleType'].invalid && addressControls['vehicleType'].touched){ @if(addressControls['vehicleType'].hasError('required')){
                    <div class="invalid-message">{{ "label-title.vehicle" | translate }} {{ "label-title.is-required" | translate }}</div>
                    } }
                  </div>
                </div>
                @if(rideDetailsForm.value.vehicleType){
                <div class="form-group position-relative ng-select">
                  <input
                    class="form-control c-pointer input-when"
                    type="text"
                    autocomplete="off"
                    readonly
                    formControlName="when"
                    #agreeSelect
                    (change)="getNearestProvider()"
                    (click)="openDateTimePickerModal()"
                    placeholder="{{ 'label-title.select-now-schedule' | translate }}"
                  />
                  @if(rideDetailsForm.value.when == helper.BookingType[helper.BookingType.SCHEDULE]){ @if(bookingTime) {
                  <a href="javascript:void(0);" class="text-body" (click)="removeSchedule()">
                    <div class="remove-icon c-pointer">
                      <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                        <path
                          opacity="0.2"
                          d="M8 0C3.581 0 0 3.582 0 8C0 12.418 3.581 16 8 16C12.419 16 16 12.418 16 8C16 3.582 12.419 0 8 0ZM11.707 10.293C11.8945 10.4805 11.9998 10.7348 11.9998 11C11.9998 11.2652 11.8945 11.5195 11.707 11.707C11.5195 11.8945 11.2652 11.9998 11 11.9998C10.7348 11.9998 10.4805 11.8945 10.293 11.707L8 9.414L5.707 11.707C5.61435 11.8002 5.50419 11.8741 5.38285 11.9246C5.26152 11.9751 5.13141 12.001 5 12.001C4.86859 12.001 4.73848 11.9751 4.61715 11.9246C4.49581 11.8741 4.38565 11.8002 4.293 11.707C4.20005 11.6142 4.12632 11.504 4.07601 11.3827C4.0257 11.2614 3.9998 11.1313 3.9998 11C3.9998 10.8687 4.0257 10.7386 4.07601 10.6173C4.12632 10.496 4.20005 10.3858 4.293 10.293L6.586 8L4.293 5.707C4.10549 5.51949 4.00015 5.26518 4.00015 5C4.00015 4.73482 4.10549 4.48051 4.293 4.293C4.48051 4.10549 4.73482 4.00015 5 4.00015C5.26518 4.00015 5.51949 4.10549 5.707 4.293L8 6.586L10.293 4.293C10.4805 4.10549 10.7348 4.00015 11 4.00015C11.2652 4.00015 11.5195 4.10549 11.707 4.293C11.8945 4.48051 11.9998 4.73482 11.9998 5C11.9998 5.26518 11.8945 5.51949 11.707 5.707L9.414 8L11.707 10.293Z"
                          fill="currentColor"
                        />
                      </svg>
                    </div>
                  </a>
                  } @else {
                  <a href="javascript:void(0);" (click)="openDateTimePickerModal()">
                    <div class="remove-icon">
                      <span class="ng-arrow-wrapper">
                        <span class="ng-arrow"></span>
                      </span>
                    </div>
                  </a>
                  } }
                </div>
                @if(rideDetailsForm.value.bookingType == helper.BookingType.RENTAL){
                <div class="col-12 mt-4">
                  <div class="d-flex align-items-center justify-content-between mb-3">
                    <h5 class="mb-0">{{ "label-title.choose-rental-package" | translate }}</h5>
                  </div>
                  <div class="form-group">
                    <ng-select
                      id="driver-map-city"
                      appearance="outline"
                      #agreeSelect
                      [searchable]="true"
                      formControlName="rentalPackage"
                      (change)="onPackageChange($event)"
                      placeholder="{{ 'label-title.select-package' | translate }}"
                      [clearable]="false"
                    >
                      @for(package of selectedVehicleType?.packageList ; track $index){
                      <ng-option [value]="package._id">{{ package.packageName | translate }}</ng-option>
                      }
                    </ng-select>
                    @if(addressControls['rentalPackage'].invalid && addressControls['rentalPackage'].touched){ @if(addressControls['rentalPackage'].hasError('required')){
                    <div class="invalid-message">{{ "label-title.rental-package" | translate }} {{ "label-title.is-required" | translate }}</div>
                    } }
                  </div>
                </div>
                } } @if(rideDetailsForm.value.bookingType === helper.BookingType.RENTAL && selectedRentalPackage){ @if(selectedRentalPackage.packageDetail.distancePrice.isActive ||
                selectedRentalPackage.packageDetail.timePrice.isActive){
                <div class="col-12 mt-2">
                  <div class="border rounded form-check-label package-style p-3">
                    <div class="d-flex">
                      @if(!selectedRentalPackage.packageDetail.distancePrice.isApplySlotPrice){
                      <p class="font-weight-medium me-1 mb-3">
                        {{ selectedRentalPackage.packageDetail.distancePrice.basePriceUnit }}
                        @if(countrySetting.distanceUnit === helper.DistanceUnit.KM){
                        {{ "label-title.km" | translate | titlecase }}
                        }@else {
                        {{ "label-title.mile" | translate | titlecase }}
                        }
                      </p>
                      } @if(!selectedRentalPackage.packageDetail.timePrice.isApplySlotPrice && !selectedRentalPackage.packageDetail.distancePrice.isApplySlotPrice){
                      <p class="font-weight-medium me-1 mb-3">
                        {{ "label-title.and" | translate }}
                      </p>
                      } @if ( !selectedRentalPackage.packageDetail.timePrice.isApplySlotPrice) {
                      <p class="font-weight-medium mb-3">
                        {{ selectedRentalPackage.packageDetail.timePrice.basePriceUnit }}
                        {{ "label-title.min" | translate | titlecase }}
                      </p>
                      }
                    </div>
                    <div class="mb-3">
                      @if(selectedRentalPackage.packageDetail.distancePrice.basePrice != 0 || selectedRentalPackage.packageDetail.distancePrice.isApplySlotPrice){
                      <p class="mb-0 font-weight-medium d-flex">
                        {{ "label-title.distance-price" | translate }}
                        @if(!selectedRentalPackage.packageDetail.distancePrice.isApplySlotPrice){ :
                        <span class="d-flex currency-gap ms-2">
                          {{ selectedRentalPackage.packageDetail.distancePrice.basePrice.toFixed(countrySetting.decimalPointValue) }}
                          <span [ngClass]="{ 'order-first': countrySetting.setCurrencySign == helper.SetCurrencySignUnit.LEFT }">
                            {{ countrySetting.currencySign }}
                          </span>
                        </span>
                        }
                      </p>
                      } @if(selectedRentalPackage.packageDetail.distancePrice.isApplySlotPrice){ @for(slot of selectedRentalPackage.packageDetail.distancePrice.slots ; track
                      $index){
                      <p class="mb-0 fs-11 font-weight-medium d-flex">
                        {{ slot.min }} @if(countrySetting.distanceUnit === helper.DistanceUnit.KM){
                        {{ "label-title.km" | translate | titlecase }}
                        }@else {
                        {{ "label-title.mile" | translate | titlecase }}
                        } - {{ slot.max === helper.backendMaxInt ? "∞" : slot.max }}
                        @if(countrySetting.distanceUnit === helper.DistanceUnit.KM){
                        {{ "label-title.km" | translate | titlecase }}
                        }@else {
                        {{ "label-title.mile" | translate | titlecase }}
                        } :
                        <span class="d-flex currency-gap ms-2">
                          {{ slot.price.toFixed(countrySetting.decimalPointValue) }}
                          <span [ngClass]="{ 'order-first': countrySetting.setCurrencySign == helper.SetCurrencySignUnit.LEFT }">
                            {{ countrySetting.currencySign }}
                          </span>
                        </span>
                      </p>

                      } }@else if(selectedRentalPackage.packageDetail.distancePrice.unitPrice != 0){
                      <p class="mb-0 fs-11 font-weight-medium d-flex">
                        {{ "label-title.extra-distance-charge" | translate }} :
                        <span class="d-flex currency-gap ms-2">
                          {{ selectedRentalPackage.packageDetail.distancePrice.unitPrice.toFixed(countrySetting.decimalPointValue) }}
                          <span [ngClass]="{ 'order-first': countrySetting.setCurrencySign == helper.SetCurrencySignUnit.LEFT }">
                            {{ countrySetting.currencySign }}
                          </span>
                        </span>
                        / @if(countrySetting.distanceUnit === helper.DistanceUnit.KM){
                        {{ "label-title.km" | translate | titlecase }}
                        }@else {
                        {{ "label-title.mile" | translate | titlecase }}
                        }
                      </p>
                      }
                    </div>
                    <div class="">
                      @if(selectedRentalPackage.packageDetail.timePrice.basePrice != 0 || selectedRentalPackage.packageDetail.timePrice.isApplySlotPrice){
                      <p class="mb-0 font-weight-medium d-flex">
                        {{ "label-title.time-price" | translate }}
                        @if(!selectedRentalPackage.packageDetail.timePrice.isApplySlotPrice){ :
                        <span class="d-flex currency-gap ms-2">
                          {{ selectedRentalPackage.packageDetail.timePrice.basePrice.toFixed(countrySetting.decimalPointValue) }}
                          <span [ngClass]="{ 'order-first': countrySetting.setCurrencySign == helper.SetCurrencySignUnit.LEFT }">
                            {{ countrySetting.currencySign }}
                          </span>
                        </span>
                        }
                      </p>

                      } @if(selectedRentalPackage.packageDetail.timePrice.isApplySlotPrice){ @for(slot of selectedRentalPackage.packageDetail.timePrice.slots ; track $index){
                      <p class="mb-0 fs-11 font-weight-medium d-flex">
                        {{ slot.min }} {{ "label-title.min" | translate | titlecase }} -
                        {{ slot.max === helper.backendMaxInt ? "∞" : slot.max }}
                        {{ "label-title.min" | translate | titlecase }} :
                        <span class="d-flex currency-gap ms-2">
                          {{ slot.price.toFixed(countrySetting.decimalPointValue) }}
                          <span [ngClass]="{ 'order-first': countrySetting.setCurrencySign == helper.SetCurrencySignUnit.LEFT }">
                            {{ countrySetting.currencySign }}
                          </span>
                        </span>
                      </p>
                      } }@else if(selectedRentalPackage.packageDetail.timePrice.unitPrice != 0){
                      <p class="mb-0 fs-11 font-weight-medium d-flex">
                        {{ "label-title.extra-time-charge" | translate }} :
                        <span class="d-flex currency-gap ms-2">
                          {{ selectedRentalPackage.packageDetail.timePrice.unitPrice.toFixed(countrySetting.decimalPointValue) }}
                          <span [ngClass]="{ 'order-first': countrySetting.setCurrencySign == helper.SetCurrencySignUnit.LEFT }">
                            {{ countrySetting.currencySign }}
                          </span>
                        </span>
                        / {{ "label-title.min" | translate | titlecase }}
                      </p>
                      }
                    </div>
                  </div>
                </div>
                } } } @if (!oneScreen && currentStep === 2 && DispatcherBookingType.length === 0 && rideDetailsForm.value.pickupAddress && vehicleTypesData) {
                <h6 class="text-danger text-center">{{ "validation-title.no-vehicles-available-in-your-area" | translate }}</h6>
                }
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
    } @if(oneScreen || currentStep > 3){
    <a
      href="javascript:;"
      data-bs-toggle="collapse"
      data-bs-target="#collapseinline"
      [attr.aria-expanded]="!BlockCollapsedThree"
      aria-expanded="true"
      aria-controls="collapseinline"
      (click)="BlockCollapseThree.toggle()"
    >
      <h5 class="mb-3">
        {{ "label-title.request-details" | translate }}
        @if(BlockCollapseThree){
        <svg xmlns="http://www.w3.org/2000/svg" width="11" height="6" viewBox="0 0 11 6" fill="none">
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M5.72115 5.75875C5.60225 5.88846 5.39775 5.88846 5.27885 5.75875L0.460824 0.502718C0.284439 0.310298 0.420939 9.24851e-07 0.68197 9.02031e-07L10.318 5.96198e-08C10.5791 3.67997e-08 10.7156 0.310297 10.5392 0.502718L5.72115 5.75875Z"
            fill="currentColor"
          />
        </svg>
        } @else {
        <svg xmlns="http://www.w3.org/2000/svg" width="11" height="6" viewBox="0 0 11 6" fill="none">
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M5.27885 0.24125C5.39775 0.11154 5.60225 0.11154 5.72115 0.24125L10.5392 5.49728C10.7156 5.6897 10.5791 6 10.318 6H0.681971C0.420939 6 0.284439 5.6897 0.460824 5.49728L5.27885 0.24125Z"
            fill="currentColor"
          />
        </svg>
        }
      </h5>
    </a>
    <div class="row g-2 mb-3">
      <div class="col-12">
        <div class="collapse show" id="collapseblock" #BlockCollapseThree="ngbCollapse" [(ngbCollapse)]="BlockCollapsedThree">
          <div class="row">
            <div class="col-12 mb-2">
              @if(selectedVehicleType?.priceDetail?.accessibilityPrices?.length > 0 || (rideDetailsForm.value.bookingType === helper.BookingType.RENTAL &&
              selectedRentalPackage?.priceDetail?.accessibilityPrices?.length > 0)) {
              <div class="accessibility-preference">
                <h6 class="mb-2">
                  {{ "heading-title.accessibility-preference" | translate | uppercase }}
                </h6>

                <div class="row">
                  <ng-template #accessibilityTemplate let-accessibilityPrices="accessibilityPrices">
                    @for (accessibilityPrice of accessibilityPrices; track $index) { @if(accessibilityPrice.name){
                    <div class="col-12 mb-2">
                      <div class="form-check form-check-secondary mb-0">
                        <input
                          class="form-check-input"
                          type="checkbox"
                          [id]="'accessibility' + $index"
                          [checked]="accessibilityPrice.isChecked"
                          (change)="onChangeAccessibility($event, accessibilityPrice)"
                        />
                        <label class="form-check-label d-flex justify-content-between" [for]="'accessibility' + $index">
                          <span>
                            {{ accessibilityPrice.name }}
                          </span>
                          <span class="d-flex currency-gap">
                            {{ accessibilityPrice?.price?.toFixed(helper.adminSettings?.decimalPointValue) }}
                            <span [ngClass]="{ 'order-first': countrySetting.setCurrencySign == helper.SetCurrencySignUnit.LEFT }">
                              {{ countrySetting.currencySign }}
                            </span>
                          </span>
                        </label>
                      </div>
                    </div>
                    } }
                  </ng-template>
                  @if(rideDetailsForm.value.bookingType === helper.BookingType.RENTAL){
                  <ng-template
                    [ngTemplateOutlet]="accessibilityTemplate"
                    [ngTemplateOutletContext]="{ accessibilityPrices: selectedRentalPackage.priceDetail.accessibilityPrices }"
                  ></ng-template>
                  } @else {
                  <ng-template
                    [ngTemplateOutlet]="accessibilityTemplate"
                    [ngTemplateOutletContext]="{ accessibilityPrices: selectedVehicleType.priceDetail.accessibilityPrices }"
                  ></ng-template>
                  }
                </div>
              </div>
              }
            </div>

            <div class="col-12 mb-3">
              <div class="form-group">
                <label class="form-label" for="message">{{ "label-title.message" | translate }}</label>
                <input type="text" class="form-control" [(ngModel)]="customerNote" placeholder="{{ 'label-title.write-note' | translate }}" />
              </div>
            </div>
            @if(userData && totalEstimatedFare + totalAccessibilityPrices <= userData.credit && userData.isUseCredit ){
            <div class="col-12 mb-3">
              <h6>{{ "heading-title.choose-payment-option" | translate | uppercase }}</h6>
              <div class="form-group">
                <ng-select
                  id="driver-map-city"
                  appearance="outline"
                  [(ngModel)]="selectedPaymentMethod"
                  #agreeSelect
                  [searchable]="true"
                  placeholder="{{ 'label-title.select-cash-card' | translate }}"
                  [clearable]="false"
                >
                  @for(mode of helper.PaymentModeListStrings ; track $index){ @if(mode.string == helper.PaymentModeStrings[1] ){
                  <ng-option [value]="mode.key">
                    <span>
                      <svg width="25" height="25" viewBox="0 0 50 50" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <g clip-path="url(#clip0_17182_775)">
                          <path
                            d="M39.5833 8.33337H10.4167C7.65501 8.33668 5.00741 9.43521 3.05462 11.388C1.10184 13.3408 0.00330804 15.9884 0 18.75L0 31.25C0.00330804 34.0117 1.10184 36.6593 3.05462 38.6121C5.00741 40.5649 7.65501 41.6634 10.4167 41.6667H39.5833C42.345 41.6634 44.9926 40.5649 46.9454 38.6121C48.8982 36.6593 49.9967 34.0117 50 31.25V18.75C49.9967 15.9884 48.8982 13.3408 46.9454 11.388C44.9926 9.43521 42.345 8.33668 39.5833 8.33337ZM8.33333 35.4167C7.92129 35.4167 7.5185 35.2945 7.1759 35.0656C6.83329 34.8367 6.56627 34.5113 6.40858 34.1306C6.2509 33.75 6.20964 33.3311 6.29003 32.9269C6.37042 32.5228 6.56883 32.1516 6.86019 31.8602C7.15155 31.5689 7.52277 31.3705 7.9269 31.2901C8.33102 31.2097 8.74991 31.2509 9.13059 31.4086C9.51127 31.5663 9.83664 31.8333 10.0656 32.1759C10.2945 32.5185 10.4167 32.9213 10.4167 33.3334C10.4167 33.8859 10.1972 34.4158 9.80647 34.8065C9.41577 35.1972 8.88587 35.4167 8.33333 35.4167ZM8.33333 18.75C7.92129 18.75 7.5185 18.6279 7.1759 18.3989C6.83329 18.17 6.56627 17.8446 6.40858 17.464C6.2509 17.0833 6.20964 16.6644 6.29003 16.2603C6.37042 15.8561 6.56883 15.4849 6.86019 15.1936C7.15155 14.9022 7.52277 14.7038 7.9269 14.6234C8.33102 14.543 8.74991 14.5843 9.13059 14.742C9.51127 14.8996 9.83664 15.1667 10.0656 15.5093C10.2945 15.8519 10.4167 16.2547 10.4167 16.6667C10.4167 17.2192 10.1972 17.7491 9.80647 18.1398C9.41577 18.5305 8.88587 18.75 8.33333 18.75ZM25 33.3334C23.3518 33.3334 21.7407 32.8446 20.3702 31.929C18.9998 31.0133 17.9317 29.7118 17.301 28.1891C16.6703 26.6664 16.5052 24.9908 16.8268 23.3743C17.1483 21.7578 17.942 20.2729 19.1074 19.1075C20.2729 17.942 21.7577 17.1484 23.3742 16.8268C24.9908 16.5053 26.6663 16.6703 28.189 17.301C29.7117 17.9318 31.0132 18.9999 31.9289 20.3703C32.8446 21.7407 33.3333 23.3519 33.3333 25C33.3333 27.2102 32.4554 29.3298 30.8926 30.8926C29.3298 32.4554 27.2101 33.3334 25 33.3334ZM41.6667 35.4167C41.2546 35.4167 40.8518 35.2945 40.5092 35.0656C40.1666 34.8367 39.8996 34.5113 39.7419 34.1306C39.5842 33.75 39.543 33.3311 39.6234 32.9269C39.7037 32.5228 39.9022 32.1516 40.1935 31.8602C40.4849 31.5689 40.8561 31.3705 41.2602 31.2901C41.6644 31.2097 42.0832 31.2509 42.4639 31.4086C42.8446 31.5663 43.17 31.8333 43.3989 32.1759C43.6278 32.5185 43.75 32.9213 43.75 33.3334C43.75 33.8859 43.5305 34.4158 43.1398 34.8065C42.7491 35.1972 42.2192 35.4167 41.6667 35.4167ZM41.6667 18.75C41.2546 18.75 40.8518 18.6279 40.5092 18.3989C40.1666 18.17 39.8996 17.8446 39.7419 17.464C39.5842 17.0833 39.543 16.6644 39.6234 16.2603C39.7037 15.8561 39.9022 15.4849 40.1935 15.1936C40.4849 14.9022 40.8561 14.7038 41.2602 14.6234C41.6644 14.543 42.0832 14.5843 42.4639 14.742C42.8446 14.8996 43.17 15.1667 43.3989 15.5093C43.6278 15.8519 43.75 16.2547 43.75 16.6667C43.75 17.2192 43.5305 17.7491 43.1398 18.1398C42.7491 18.5305 42.2192 18.75 41.6667 18.75ZM29.1667 25C29.1667 25.8241 28.9223 26.6297 28.4645 27.3149C28.0066 28.0001 27.3559 28.5342 26.5945 28.8495C25.8332 29.1649 24.9954 29.2474 24.1871 29.0866C23.3789 28.9259 22.6364 28.529 22.0537 27.9463C21.471 27.3636 21.0742 26.6212 20.9134 25.8129C20.7526 25.0047 20.8351 24.1669 21.1505 23.4055C21.4659 22.6442 21.9999 21.9934 22.6851 21.5356C23.3703 21.0777 24.1759 20.8334 25 20.8334C26.1051 20.8334 27.1649 21.2724 27.9463 22.0538C28.7277 22.8352 29.1667 23.895 29.1667 25Z"
                            fill="currentColor"
                          />
                        </g>
                        <defs>
                          <clipPath id="clip0_17182_775">
                            <rect width="50" height="50" fill="white" />
                          </clipPath>
                        </defs>
                      </svg>
                      {{ mode.string | translate }}
                    </span>
                  </ng-option>
                  } @else if(mode.string == helper.PaymentModeStrings[2] ){
                  <ng-option [value]="mode.key">
                    <span>
                      <svg width="25" height="25" viewBox="0 0 50 50" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <g clip-path="url(#clip0_7346_2071)">
                          <path
                            d="M39.5833 6.25H10.4167C7.65501 6.25331 5.00741 7.35184 3.05462 9.30463C1.10184 11.2574 0.00330804 13.905 0 16.6667H50C49.9967 13.905 48.8982 11.2574 46.9454 9.30463C44.9926 7.35184 42.345 6.25331 39.5833 6.25Z"
                            fill="currentColor"
                          />
                          <path
                            d="M0 33.3333C0.00330804 36.0949 1.10184 38.7425 3.05462 40.6953C5.00741 42.6481 7.65501 43.7466 10.4167 43.7499H39.5833C42.345 43.7466 44.9926 42.6481 46.9454 40.6953C48.8982 38.7425 49.9967 36.0949 50 33.3333V20.8333H0V33.3333ZM14.5833 32.2916C14.5833 32.9097 14.4001 33.5138 14.0567 34.0277C13.7133 34.5416 13.2252 34.9422 12.6542 35.1787C12.0832 35.4152 11.4549 35.4771 10.8487 35.3565C10.2425 35.236 9.68566 34.9383 9.24862 34.5013C8.81158 34.0643 8.51396 33.5074 8.39338 32.9012C8.2728 32.2951 8.33469 31.6667 8.57121 31.0957C8.80773 30.5247 9.20827 30.0366 9.72218 29.6932C10.2361 29.3499 10.8403 29.1666 11.4583 29.1666C12.2871 29.1666 13.082 29.4958 13.668 30.0819C14.2541 30.6679 14.5833 31.4628 14.5833 32.2916Z"
                            fill="currentColor"
                          />
                        </g>
                        <defs>
                          <clipPath id="clip0_7346_2071">
                            <rect width="50" height="50" fill="white" />
                          </clipPath>
                        </defs>
                      </svg>
                      {{ mode.string | translate }}
                      ( {{ userData?.credit?.toFixed(countrySetting.decimalPointValue) }}
                      <span [ngClass]="{ 'order-first': countrySetting.setCurrencySign == helper.SetCurrencySignUnit.LEFT }"> {{ countrySetting.currencySign }} </span>)
                    </span>
                  </ng-option>
                  } }
                </ng-select>
              </div>
            </div>
            } @if(agencies.length > 0 && bookingSetting?.ShowAgencySelection){
            <div class="col-12 mb-3">
              <h6>{{ "heading-title.choose-agency" | translate | uppercase }}</h6>
              <div class="form-group">
                <ng-select
                  id="agency"
                  appearance="outline"
                  [(ngModel)]="selectedAgencyId"
                  #agreeSelect
                  [searchable]="true"
                  placeholder="{{ 'label-title.select-agency' | translate }}"
                  [clearable]="true"
                >
                  @for(agency of agencies ; track $index){
                  <ng-option [value]="agency._id">{{ agency.name | translate }}</ng-option>
                  }
                </ng-select>
                @if(isAgencyError){
                <div class="invalid-message">{{ "label-title.agency" | translate }} {{ "label-title.is-required" | translate }}</div>
                }
              </div>
            </div>
            }
            <div class="col-12">
              <div class="form-check form-check-dark">
                <div class="mb-3">
                  <input
                    type="checkbox"
                    id="formCheck12"
                    [checked]="isManually == helper.bookingDriverAssignEnum.NEAREST_DRIVER"
                    class="form-check-input rounded-circle"
                    (click)="onDriverAssignChange(helper.bookingDriverAssignEnum.NEAREST_DRIVER, $event)"
                  /><label for="formCheck12" class="form-check-label"> {{ "label-title.assign-nearest-driver" | translate }}</label>
                </div>
                <div class="mb-3">
                  <input
                    type="checkbox"
                    id="formCheck13"
                    [checked]="isManually == helper.bookingDriverAssignEnum.MANUALLY"
                    class="form-check-input rounded-circle"
                    (click)="onDriverAssignChange(helper.bookingDriverAssignEnum.MANUALLY, $event)"
                  /><label for="formCheck13" class="form-check-label"> {{ "label-title.manually-assign-driver" | translate }}</label>
                </div>
                @if(isManually == helper.bookingDriverAssignEnum.MANUALLY){
                <ng-select
                  id="driver-map-city"
                  appearance="outline"
                  [(ngModel)]="driverId"
                  #agreeSelect
                  [searchable]="true"
                  placeholder="{{ 'label-title.select-driver' | translate }}"
                  [clearable]="false"
                >
                  @for(provider of nearestProvider ; track $index){
                  <ng-option [value]="provider._id">{{ provider.firstName }} {{ provider.lastName }}</ng-option>
                  }
                </ng-select>
                @if(!this.driverId){
                <div class="invalid-message">{{ "label-title.driver" | translate }} {{ "label-title.is-required" | translate }}</div>
                } }
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    }
  </div>
  <div class="d-flex align-items-start justify-content-end gap-3 pt-3 pe-4 btn-steps" [ngClass]="{ 'justify-content-between': currentStep > 1 }">
    @if(currentStep > 1){
    <button type="button" class="btn btn-soft-info btn-sm py-2 px-3 d-flex justify-content-center" (click)="goToPrevious(currentStep)">
      <i class="las la-long-arrow-alt-left fs-16 me-1"></i> {{ "button-title.previous" | translate }}
    </button>
    } @if(currentStep != 4){
    <button type="button" class="btn btn-secondary btn-sm" (click)="continue(currentStep)"><i class="ri-arrow-right-line label-icon align-middle fs-18"></i></button>
    } @if(oneScreen && currentStep != 4){
    <button type="button" class="btn btn-success" (click)="bookFromOneScreen()">Book R-Hero Ride</button>
    } @if(currentStep == 4){
      @if(selectedBusinessType === BusinessType.TOWING && questionsList.length > 0) {
        <!-- 🆕 Show "Continue" to trigger questions modal first -->
        <button type="button" class="btn btn-secondary" (click)="onFixFare()">
          {{ "button-title.continue" | translate }}
          <i class="las la-long-arrow-alt-right fs-16 ms-1"></i>
        </button>
      } @else {
        <button type="button" class="btn btn-secondary" (click)="onFixFare()">
          {{ "button-title.book-ride" | translate }}
        </button>
      }
    }
  </div>
</div>


@if(isShowQuestionsModal && questionsList.length > 0) {
<div class="modal-overlay" style="position:fixed;top:0;left:0;width:100%;height:100%;background:rgba(0,0,0,0.5);z-index:1050;display:flex;align-items:center;justify-content:center;">
  <div class="card mb-0" style="width:90%;max-width:500px;max-height:80vh;overflow-y:auto;">
    <div class="card-body">
      <!-- Progress -->
      <div class="d-flex justify-content-between align-items-center mb-3">
        <h5 class="mb-0">
          {{ "label-title.question" | translate }} {{ currentQuestionIndex + 1 }} / {{ questionsList.length }}
        </h5>
        <button class="btn btn-sm btn-link text-muted" (click)="isShowQuestionsModal = false">
          <em class="ri-close-line fs-18"></em>
        </button>
      </div>

      <!-- Progress bar -->
      <div class="progress mb-4" style="height:4px;">
        <div class="progress-bar bg-secondary"
          [style.width.%]="((currentQuestionIndex + 1) / questionsList.length) * 100">
        </div>
      </div>

      @if(questionsList[currentQuestionIndex]; as currentQ) {
        <h6 class="mb-3">{{ currentQ.cuurentLangQuestionText || currentQ.questionText }}</h6>

        <!-- SINGLE_OPTION -->
        @if(currentQ.questionType === 'SINGLE_OPTION') {
          <div class="vstack gap-2">
            @for(option of currentQ.options; track $index) {
              <div class="form-check card-radio position-relative">
                <input
                  type="radio"
                  [id]="'sq-opt-' + $index"
                  class="form-check-input"
                  [name]="'single-q-' + currentQ._id"
                  [value]="String($index)"
                  [(ngModel)]="currentQ.answer"
                  [ngModelOptions]="{standalone: true}"
                />
                <label class="form-check-label px-3 py-2 w-100" [for]="'sq-opt-' + $index">
                  {{ helper.cuurentLang ? option.label[helper.cuurentLang] : option.label['en'] }}
                </label>
              </div>
            }
          </div>
        }

        <!-- MULTI_OPTION -->
        @if(currentQ.questionType === 'MULTI_OPTION') {
          <div class="vstack gap-2">
            @for(option of currentQ.options; track $index) {
              <div class="form-check card-radio position-relative">
                <input
                  type="checkbox"
                  [id]="'mq-opt-' + $index"
                  class="form-check-input"
                  [checked]="currentQ.selectedOptions?.includes(String($index))"
                  (change)="toggleMultiOption(currentQ, $index)"
                />
                <label class="form-check-label px-3 py-2 w-100" [for]="'mq-opt-' + $index">
                  {{ helper.cuurentLang ? option.label[helper.cuurentLang] : option.label['en'] }}
                </label>
              </div>
            }
          </div>
        }

        <!-- FREE_TEXT -->
        @if(currentQ.questionType === 'FREE_TEXT') {
          <textarea
            class="form-control"
            [rows]="4"
            [(ngModel)]="currentQ.answer"
            [ngModelOptions]="{standalone: true}"
            placeholder="{{ 'label-title.enter-your-answer' | translate }}"
          ></textarea>
        }

        <!-- NUMBER -->
        @if(currentQ.questionType === 'NUMBER') {
          <input
            type="number"
            class="form-control"
            [(ngModel)]="currentQ.answer"
            [ngModelOptions]="{standalone: true}"
            placeholder="{{ 'label-title.enter-number' | translate }}"
          />
        }

        <!-- IMAGE -->
        @if(currentQ.questionType === 'IMAGE') {
          <div>
            <label
              class="btn btn-outline-secondary btn-sm mb-2"
              [class.disabled]="currentQ.selectedImages?.length >= 5"
              style="cursor:pointer;"
            >
              <em class="ri-image-add-line me-1"></em>
              {{ "button-title.select-images" | translate }}
              ({{ currentQ.selectedImages?.length || 0 }}/5)
              <input
                type="file"
                multiple
                accept="image/*"
                style="display:none;"
                [disabled]="currentQ.selectedImages?.length >= 5"
                (change)="onQuestionImageSelected($event, currentQ)"
              />
            </label>
            @if(currentQ.selectedImages?.length > 0) {
              <div class="d-flex flex-wrap gap-2 mt-2">
                @for(img of currentQ.selectedImages; track $index) {
                  <div class="position-relative" style="width:70px;height:70px;">
                    <img
                      [src]="getObjectUrl(img)"
                      style="width:70px;height:70px;object-fit:cover;border-radius:8px;"
                      alt="selected"
                    />
                    <button
                      class="btn btn-sm btn-danger position-absolute"
                      style="top:-6px;right:-6px;padding:0 4px;line-height:16px;font-size:11px;border-radius:50%;"
                      (click)="removeQuestionImage(currentQ, $index)"
                    >×</button>
                  </div>
                }
              </div>
            }
          </div>
        }
      }

      <!-- Actions -->
      <div class="d-flex justify-content-between align-items-center mt-4">
        <button
          class="btn btn-soft-info btn-sm py-2 px-3"
          [disabled]="currentQuestionIndex === 0"
          (click)="currentQuestionIndex = currentQuestionIndex - 1"
        >
          <i class="las la-long-arrow-alt-left fs-16 me-1"></i>
          {{ "button-title.previous" | translate }}
        </button>

        @if(currentQuestionIndex < questionsList.length - 1) {
          <button class="btn btn-soft-secondary btn-sm py-2 px-3" (click)="onQuestionContinue()">
            {{ "button-title.continue" | translate }}
            <i class="las la-long-arrow-alt-right fs-16 ms-1"></i>
          </button>
        } @else {
          <button class="btn btn-secondary btn-sm py-2 px-3" (click)="onQuestionContinue()">
            {{ "button-title.book-ride" | translate }}
          </button>
        }
      </div>

    </div>
  </div>
</div>
}

<app-country-phonecode #countryCodeModal (countryChange)="changePhoneCode($event)"></app-country-phonecode>
<app-view-fare-estimate-modal
  #viewFareEstimate
  (updateTotal)="calculateTotal($event)"
  [accessibilityList]="vehicleTypesData?.accessibilities"
  [customPrices]="vehicleTypesData?.customPrices"
></app-view-fare-estimate-modal>
<app-fix-fare-trip-modal #fixFareModal (fixFareEvent)="createRide($event, [])"></app-fix-fare-trip-modal>
<app-surge-price-modal #surgePrice (surgePriceEvent)="onSurgePriceApplied($event)"></app-surge-price-modal>
<app-booking-vehicle-filter-modal #bookingVehicleFilterModal (onApplyFilter)="onApplyFilter($event)"></app-booking-vehicle-filter-modal>
<app-date-time-picker-modal #dateTimePickerModal (dateSelected)="onDateSelected($event)"></app-date-time-picker-modal>
